import React from "react";
import { Map, Building2, Sun, Heart, Ship, Users } from "lucide-react";
import { services } from "../mock";

const icons = { Map, Building2, Sun, Heart, Ship, Users };

const Services = () => {
  return (
    <section id="diensten" className="py-24 bg-[#f2ece1]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal text-center max-w-2xl mx-auto">
          <span className="text-xs font-600 uppercase tracking-[0.25em] text-[#86233a]">Wat ik voor je doe</span>
          <h2 className="font-display mt-4 text-4xl lg:text-5xl font-600 text-[#1d1c1a]">
            Reizen voor ieder moment
          </h2>
          <p className="mt-4 text-lg text-[#4b4642]">
            Welk type reis je ook zoekt, ik stel het voor je samen, tot in de
            kleinste details.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = icons[s.icon];
            return (
              <div
                key={s.title}
                className="reveal group rounded-2xl bg-white p-8 border border-[#e9dfce] shadow-[0_10px_30px_-18px_rgba(83,14,47,0.25)] hover:shadow-[0_24px_50px_-20px_rgba(134,35,58,0.4)] hover:-translate-y-1.5 transition-all duration-300"
                style={{ transitionDelay: `${i * 40}ms` }}
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-[#ffd7d4] text-[#86233a] group-hover:bg-[#86233a] group-hover:text-white transition-colors duration-300">
                  <Icon size={26} />
                </div>
                <h3 className="font-display mt-6 text-2xl text-[#1d1c1a]">{s.title}</h3>
                <p className="mt-3 text-[#4b4642] leading-relaxed">{s.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
